export default "__VITE_ASSET__bMGGUwKM__"